import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import {
	GoalCategoryTypeEnum,
	type GoalDetailResponseDTO,
	GoalStateEnum,
} from "web_myplann/Infrastructure/Api/Api";

type MapGoalDetailDtoParams = {
	id: string;
	dto: GoalDetailResponseDTO;
	dueIn: string;
};

export const mapGoalDetailDto = ({
	id,
	dto,
	dueIn,
}: MapGoalDetailDtoParams): GoalDetail => {
	const dueYear = dto.targetDate
		? new Date(dto.targetDate).getFullYear()
		: new Date().getFullYear();

	return {
		id,
		name: dto.name ?? "",
		category: dto.investmentPlanCategoryType ?? GoalCategoryTypeEnum.Basic,
		status: dto.coveredState ?? null,
		completed: dto.state === GoalStateEnum.Completed,
		allowEditByClient: dto.allowEditByClient,
		price: dto.oneTimePayment ?? null,
		savingsTarget: dto.targetAmount ?? 0,
		ownFunds: dto.ownFunds ?? 0,
		loanAmount: dto.loanAmount ?? 0,
		coveredAmount: dto.coveredAmount ?? 0,
		dueYear,
		dueIn,
		currencyCode: dto.currencyCode ?? undefined,
		portfolios: dto.portfolios,
		futurePortfolios: dto.futurePortfolios,
		rentMode: dto.rentMode,
		monthlyRent: dto.monthlyRent ?? 0,
		rentYears: dto.rentYears ?? 0,
		agent: dto.fromAgent
			? { id: dto.fromAgent.id, name: dto.fromAgent.name }
			: undefined,
	};
};
